module.exports = __webpack_public_path__ + "static/media/zx_logo.ddfd786b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zx_logo.png
// module id = 2711
// module chunks = 2